import React from 'react';
import { Zap, Clock, Sparkles, CheckCircle, Gem, Truck, ShieldCheck } from 'lucide-react';
export function Protocolo7dias() {
  return <section className="py-24 bg-[#1a1a1a] text-white overflow-hidden relative" data-id="element-267">
      {/* Decoración de lujo */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#D4AF37]/10 blur-[120px] rounded-full -mr-48 -mt-48" data-id="element-268"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#FADADD]/10 blur-[120px] rounded-full -ml-48 -mb-48" data-id="element-269"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-270">
        
        {/* PARTE 1: EL PROTOCOLO (SECCIÓN SUPERIOR) */}
        <div className="flex flex-col lg:flex-row items-center gap-16 mb-32" data-id="element-271">
          <div className="w-full lg:w-1/2 relative" data-id="element-272">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-white/10" data-id="element-273">
              <img src="https://cdn.shopify.com/s/files/1/0691/5312/8522/files/Gemini_Generated_Image_lu9aqvlu9aqvlu9a.jpg?v=1771959805" className="w-full h-auto object-cover transform hover:scale-105 transition-transform duration-700" alt="Protocolo Flash 7 Días" data-id="element-274" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a] via-transparent to-transparent opacity-60" data-id="element-275"></div>
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#D4AF37] p-6 rounded-2xl shadow-xl hidden md:block animate-bounce-slow" data-id="element-276">
              <p className="text-black font-black text-center leading-tight" data-id="element-277">
                RESULTADOS <br data-id="element-278" /> <span className="text-xl" data-id="element-279">48H</span>
              </p>
            </div>
          </div>

          <div className="w-full lg:w-1/2" data-id="element-280">
            <span className="text-[#FADADD] font-bold tracking-[0.3em] text-xs uppercase mb-4 block" data-id="element-281">Acelerador de Resultados</span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading mb-8 leading-[1.1]" data-id="element-282">
              Protocolo Flash: <br data-id="element-283" />
              <span className="italic text-[#D4AF37]" data-id="element-284">Desinflamación 7 Días</span>
            </h2>
            <p className="text-gray-400 text-lg mb-10 font-light leading-relaxed" data-id="element-285">
              ¿Tienes un evento especial? Este sistema intensivo es para quienes necesitan un <strong data-id="element-286">cambio radical hoy</strong> usando técnicas de alta presión.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mb-10" data-id="element-287">
              <div className="flex gap-4" data-id="element-288">
                <Zap className="text-[#FADADD] w-6 h-6 flex-shrink-0" data-id="element-289" />
                <div data-id="element-290">
                  <h4 className="font-bold text-white text-sm" data-id="element-291">Efecto Shock</h4>
                  <p className="text-gray-500 text-xs" data-id="element-292">Drenaje profundo de líquidos estancados.</p>
                </div>
              </div>
              <div className="flex gap-4" data-id="element-293">
                <Clock className="text-[#FADADD] w-6 h-6 flex-shrink-0" data-id="element-294" />
                <div data-id="element-295">
                  <h4 className="font-bold text-white text-sm" data-id="element-296">7 Minutos / Día</h4>
                  <p className="text-gray-500 text-xs" data-id="element-297">Máxima eficiencia para agendas ocupadas.</p>
                </div>
              </div>
            </div>

            {/* ✅ BLOQUE AÑADIDO PARA EL PROTOCOLO */}
            <div className="inline-flex items-center gap-2 px-6 py-3 bg-white/5 border border-white/10 rounded-full" data-id="element-298">
              <CheckCircle className="w-4 h-4 text-[#FADADD]" data-id="element-299" />
              <span className="text-xs uppercase tracking-widest text-[#FADADD] font-bold" data-id="element-300">Disponible en el Pack Radiante</span>
            </div>
          </div>
        </div>

        {/* LÍNEA DIVISORA ELEGANTE */}
        <div className="w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-32" data-id="element-301"></div>

        {/* PARTE 2: EL KIT FÍSICO (SECCIÓN INFERIOR) */}
        <div className="flex flex-col lg:flex-row-reverse items-center gap-16" data-id="element-302">
          <div className="w-full lg:w-1/2 relative" data-id="element-303">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl border border-white/5" data-id="element-304">
              <img src="https://cdn.shopify.com/s/files/1/0691/5312/8522/files/Gemini_Generated_Image_imo9g4imo9g4imo9.jpg?v=1771954185" className="w-full h-auto object-cover" alt="Kit Escultor Cuarzo Rosa" data-id="element-305" />
            </div>
          </div>

          <div className="w-full lg:w-1/2" data-id="element-306">
            <span className="text-[#D4AF37] font-bold tracking-[0.2em] text-xs uppercase mb-4 block" data-id="element-307">Herramienta Profesional</span>
            <h2 className="text-4xl md:text-5xl font-heading mb-8 leading-tight" data-id="element-308">
              Kit Escultor: <br data-id="element-309" />
              <span className="italic text-gray-400 font-serif text-3xl md:text-4xl" data-id="element-310">Cuarzo Rosa 100% Auténtico</span>
            </h2>
            <p className="text-gray-400 text-lg mb-10 font-light" data-id="element-311">
              El complemento físico indispensable. La piedra fría cierra poros, calma la piel y permite que el <strong data-id="element-312">Protocolo de 7 días</strong> sea el doble de efectivo.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mb-10" data-id="element-313">
              <div className="flex items-center gap-4 group" data-id="element-314">
                <Gem className="w-5 h-5 text-[#D4AF37]" data-id="element-315" />
                <span className="text-sm text-gray-300 group-hover:text-white transition-colors" data-id="element-316">Piedra Genuina (Crioterapia Natural)</span>
              </div>
              <div className="flex items-center gap-4 group" data-id="element-317">
                <Truck className="w-5 h-5 text-[#D4AF37]" data-id="element-318" />
                <span className="text-sm text-gray-300 group-hover:text-white transition-colors" data-id="element-319">Envío Priority (1-7 días USA)</span>
              </div>
            </div>

            {/* BLOQUE PARA EL KIT VIP */}
            <div className="inline-flex items-center gap-2 px-6 py-3 bg-white/5 border border-white/10 rounded-full" data-id="element-320">
              <CheckCircle className="w-4 h-4 text-[#D4AF37]" data-id="element-321" />
              <span className="text-xs uppercase tracking-widest text-[#D4AF37] font-bold" data-id="element-322">Disponible en el Pack VIP</span>
            </div>
          </div>
        </div>
      </div>

      <style jsx data-id="element-323">{`
        @keyframes bounce-slow {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        .animate-bounce-slow {
          animation: bounce-slow 3s ease-in-out infinite;
        }
      `}</style>
    </section>;
}